import React, { useEffect, useState } from "react";
import { useBluelagoon } from "@bluelagoon";
import { AlertTriangle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@shadcn-in-nx/ui/popover";
import { Badge } from "@shadcn-in-nx/ui/badge";

export default function HarnessReportBadge({ stepChatId }) {
    const [reports, setReports] = useState([]);
    const { call: fetchReports } = useBluelagoon({ method: "getReportsByStepChat" });

    useEffect(() => {
        if (!stepChatId) return;
        fetchReports({ stepChatId }).then((res) => {
            if (res?.data?.reports) setReports(res.data.reports);
        });
    }, [stepChatId]);

    if (reports.length === 0) return null;

    return (
        <Popover>
            <PopoverTrigger asChild>
                <button className="flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-red-50 text-red-700 hover:bg-red-100 transition-colors">
                    <AlertTriangle className="w-3 h-3" />
                    {reports.length} Report{reports.length > 1 ? "s" : ""}
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-80 max-h-64 overflow-y-auto p-3" align="end">
                <p className="text-sm font-medium mb-2">Harness Reports</p>
                <div className="space-y-2">
                    {reports.map((r) => (
                        <div key={r.id} className="border rounded p-2 text-xs space-y-1">
                            <div className="flex items-center gap-2">
                                <Badge variant="outline" className="text-[10px]">{r.category || r.type}</Badge>
                                {r.resolved && <Badge className="bg-green-100 text-green-800 text-[10px]">Resolved</Badge>}
                                <span className="text-muted-foreground ml-auto">{new Date(r.createdAt).toLocaleDateString()}</span>
                            </div>
                            <p className="text-muted-foreground line-clamp-2">{r.objective}</p>
                        </div>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
}
